import * as React from "react";
const SFOCView = React.lazy(() => import("./SFOCViewContainer"));

export { SFOCView };
